var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 18.6665C19.6816 18.6665 22.6663 15.0848 22.6663 10.6665C22.6663 6.24823 19.6816 2.6665 15.9997 2.6665C12.3178 2.6665 9.33301 6.24823 9.33301 10.6665C9.33301 15.0848 12.3178 18.6665 15.9997 18.6665Z",
    fill: "#6E7191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0666 25.4665C27.8666 23.0665 25.6 21.0665 22.6666 19.8665C21.8666 19.5998 20.9333 19.5998 20.2666 19.9998C18.9333 20.7998 17.6 21.1998 16 21.1998C14.4 21.1998 13.0666 20.7998 11.7333 19.9998C11.0666 19.7332 10.1333 19.5998 9.3333 19.9998C6.39996 21.1998 4.1333 23.1998 2.9333 25.5998C1.99996 27.3332 3.46663 29.3332 5.46663 29.3332H26.5333C28.5333 29.3332 30 27.3332 29.0666 25.4665Z",
    fill: "#6E7191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8f3f4f69fa39601eb5b82b179b258096.svg";
export { ForwardRef as ReactComponent };